import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import MachineCard from './MachineCard'
import { useServerConnection } from '../hooks/ServerConnection'
import { useEventStream } from '../hooks/eventStream'
import { Machine } from 'common/types/Machine'
import { ForwardInfo } from 'common/types/ForwardInfo'
import { useGitlabAccessToken } from '../hooks/GitlabAccessToken'
import VMBuildingLogs from './VMBuildingLogs'
import { useSearchParams } from 'react-router-dom'


const MachinesList = ({ repo, createVMComponent }: { repo?: { namespace: string, project: string }, createVMComponent?: JSX.Element }) => {
    const [accessToken] = useGitlabAccessToken()
    const navigate = useNavigate()
    const serverConnection = useServerConnection()

    const [seachParams] = useSearchParams()
    const namespace = seachParams.get('namespace');
    const project = seachParams.get('project');
    const ref = seachParams.get('ref');

    const [machines, setMachines] = useState<{
        [machineId: string]: {
            machine: Machine,
            forwardInfo: ForwardInfo,
        },
    }>(null)
    useEventStream(async () => {
        const result = await serverConnection.getUserMachinesStream(accessToken)

        if(result.type === "error") {
            if(namespace && project) {
                navigate(`/request-access-code?project=${project}&namespace=${namespace}${ref ? `&ref=${ref}` : ''}`)
            } else {
                navigate(`/request-access-code`)
            }
            return null
        } else {
            return result
        }
    }, (update) => {
        if(update.type === "init") {
            setMachines(update.machines)
        } else if(update.type === "machine update") {
            setMachines((machines) => {
                return {
                    ...machines,
                    [update.machine._id]: {
                        machine: update.machine,
                        forwardInfo: update.forwardInfo,
                    }
                }
            })
        } else if(update.type === "machine remove") {
            setMachines((machines) => {
                const machinesCopy = {
                    ...machines,
                }
                delete machinesCopy[update.machineId]
                
                return machinesCopy
            })
        }
    }, [serverConnection])

    if(machines === null) {
        return <div/>
    }


    return (
        <div style={{
            display: "flex",
            flexWrap: "wrap",
        }}>
            <div className='p-6' style={{
                flex: 1,
            }}>
                {createVMComponent}
                <div style={{
                    marginTop: 20,
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
                    gridAutoRows: 310,
                    gap: 40,
                }}>
                    {Object.keys(machines).filter((machineId) => {
                        const { machine } = machines[machineId]

                        if(repo) {
                            return machine.namespace === repo.namespace
                                && machine.project === repo.project
                        } else {
                            return true
                        }
                    }).map((machineId) => {
                        const { machine, forwardInfo } = machines[machineId]

                        return (
                            <MachineCard key={machine._id} machine={machine} forwardInfo={forwardInfo} />
                        )
                    })}
                </div>
            </div>
            <div style={{
                minWidth: 540,
            }}>
                <VMBuildingLogs/>
            </div>
        </div>
    )

}

export default MachinesList